import { render, staticRenderFns } from "./donut_chart.vue?vue&type=template&id=1ce3a25a&"
import script from "./donut_chart.vue?vue&type=script&lang=js&"
export * from "./donut_chart.vue?vue&type=script&lang=js&"
import style0 from "./donut_chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports